import {
    HttpEvent,
    HttpHandler,
    HttpHeaders,
    HttpInterceptor,
    HttpRequest,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { load } from "@fingerprintjs/fingerprintjs";
import { Store } from "@ngrx/store";
import { AutoUnsubscribe } from "ngx-auto-unsubscribe";
import { Observable } from "rxjs/Observable";
import { switchMap, take } from "rxjs/operators";
import { AppState } from "../interfaces/app-state.interface";
import { SettingsService } from "../services/settings/settings.service";
import * as GetResult from '@fingerprintjs/fingerprintjs';

type GetResult = any;

@AutoUnsubscribe()
@Injectable()
export class AuthorizationInterceptor implements HttpInterceptor {
    private readonly PLATFORM_IDENTIFIER = "x-toro-platform-identifier";
    private readonly PLATFORM_ORIGIN = "x-toro-platform-origin";
    private readonly PLATFORM_NAME: string = "HubToro";
    private VISITORID: string | null;
    private readonly AUTHORIZATION_KEY = "Authorization";

    constructor(
        private store: Store<AppState>,
        private settingsService: SettingsService
    ) {}

    /**
     * Intercepa requisiçãoes de determina se elas devem ou não conter o cabeçalho Authorization
     *
     * @param request
     */
    public intercept(
        request: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        const sendNewHeaders: boolean = this.sendNewHeaders(request);

        if (!sendNewHeaders) {
            if (
                !this.isInterceptable(request.url) ||
                request.headers.has(this.AUTHORIZATION_KEY)
            ) {
                return next.handle(request);
            }
        } else {
            if (
                !this.isInterceptable(request.url) ||
                (request.headers.has(this.AUTHORIZATION_KEY) &&
                    request.headers.has(this.PLATFORM_IDENTIFIER) &&
                    request.headers.has(this.PLATFORM_ORIGIN))
            ) {
                return next.handle(request);
            }
        }

        return this.store
            .select((state) => state.authentication.currentUser)
            .pipe(
                take(1),
                switchMap((currentUser) => {
                    if (!currentUser || !currentUser.token) {
                        return next.handle(request);
                    }

                    if (this.VISITORID != null) {
                        const newheaders = this.getHeaders(
                            currentUser.token,
                            request,
                            sendNewHeaders
                        );

                        const newRequest = request.clone({
                            headers: newheaders,
                        });
                        return next.handle(newRequest);
                    } else {
                        const promise = new Promise<any>(async (resolve) => {
                            const identifier = await this.getIdentifier();
                            if (identifier != null) {
                                this.VISITORID = identifier.visitorId;

                                const newheaders = this.getHeaders(
                                    currentUser.token,
                                    request,
                                    sendNewHeaders
                                );

                                const newRequest = request.clone({
                                    headers: newheaders,
                                });

                                resolve(newRequest);
                            }
                        });

                        return Observable.fromPromise(promise).switchMap(
                            (modifiedRequest: HttpRequest<any>) => {
                                return next.handle(modifiedRequest);
                            }
                        );
                    }
                })
                // catchError(() => next.handle(request)),
            );
    }

    /**
     * Verifica se a URL da requisição está na lista de URLs de backend definidas no environemnt
     *
     * @param url
     */
    private isInterceptable(url: string) {
        const { backend } = this.settingsService.getSettingsSnapshot();

        if (!backend) return false;

        return Object.values(backend).some((baseUrl: string) =>
            url.includes(baseUrl)
        );
    }
    /**
     * Busca o identificador do navegador
     */
    async getIdentifier(): Promise<GetResult> {
        try {
            const fingerprintjs = await load();
            return await fingerprintjs.get();
        } catch (error) {
            return null;
        }
    }
    /**
     * Adiciona os headers
     * @param token
     * @param request
     * @param sendNewHeaders
     */
    private getHeaders(
        token: string,
        request: HttpRequest<any>,
        sendNewHeaders: boolean
    ): HttpHeaders {
        if (!sendNewHeaders) {
            return request.headers.set(
                this.AUTHORIZATION_KEY,
                `Bearer ${token}`
            );
        }
        return request.headers
            .set(this.PLATFORM_IDENTIFIER, this.VISITORID)
            .set(this.AUTHORIZATION_KEY, `Bearer ${token}`)
            .set(this.PLATFORM_ORIGIN, this.PLATFORM_NAME);
    }
    /**
     * Método temporário para verificar se devemos enviar os novos headers.Atualmente somente a webapieqr está apta para receber
     * @param request
     */
    private sendNewHeaders(request: HttpRequest<any>): boolean {
        return request.url.includes("webapieqr") || request.url.includes("rf-apis") || request.url.includes("user/v");
    }
}
